import { NgModule } from '@angular/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WorkItemPreviewLaneButtonsComponent } from 'components/queue-view/queue-view-tab/work-item-preview/preview-lane-buttons/work-item-preview-lane-buttons.component';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    SvgIconModule,
    CommonModule,
    TooltipModule,
    TranslateModule.forChild()

  ],
  declarations: [
    WorkItemPreviewLaneButtonsComponent
  ],
  exports: [
    WorkItemPreviewLaneButtonsComponent
  ]
})
export class WorkItemPreviewLaneButtonsModule {}
